import { Dialog } from "primereact/dialog"
import { ProgressSpinner } from "primereact/progressspinner"
import React, { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { Api } from "../services/Api"
import { formatCurrency } from "../utils/FormatCurrency"


function InfoProtestoDialog({close,taxaSelecionada}){

    const [infoProtestoDetalhada,setInfoProtestoDetalhada] = useState([])
    const [loading,setLoading] = useState(true)

    const getProtestoDetalhes = async() =>{
    try {
    //    const { data } = await Api.get(`/paguecartorio/cobranca/detalhe/cfeb1dc3-bcb2-45a9-a893-496a3ceb552e`)
        const { data } = await Api.get(`/paguecartorio/cobranca/detalhe/${taxaSelecionada.cobranca_id}`)
        if(data[0]){
        setInfoProtestoDetalhada(data[0]);
        setLoading(false);
        } else
        toast.error('Erro de conexão')
    } catch (error) {
        console.log(error);
        toast.error('Erro de conexão');
    }
}
    useEffect(()=>{
        getProtestoDetalhes();
    },[])

    return (
        <Dialog
        visible
        header="Detalhes da taxa"
        onHide={()=>close()}
        className="boletosDialog"
        style={{
            minHeigth:'30vw', 
            minWidth: '20vw', 
            textAlign: 'center', 
        }}
        >
            <div className="text-center font-branding-bold p-6">
                { loading ?
                <ProgressSpinner strokeWidth="7" fill="transparent" animationDuration=".5s" /> :
                <div> 
                    <h6 className="text-slate-500">APRESENTANTE</h6>
                    <h5>{infoProtestoDetalhada.apresentante_nome}</h5>
                    <h6 className="text-slate-500">DATA SOLICITAÇÃO CANCELAMENTO</h6>
                    <h5>{infoProtestoDetalhada.data_solicitacao}</h5>
                    <h6 className="text-slate-500">DATA PROTOCOLO CARTÓRIO</h6>
                    <h5>{infoProtestoDetalhada.protocolo_data}</h5>
                    <h6 className="text-slate-500">PROTOCOLO CARTÓRIO</h6>
                    <h5>{infoProtestoDetalhada.protocolo_cartorio}</h5>
                    <h6 className="text-slate-500">NÚMERO DO TÍTULO</h6>
                    <h5>{infoProtestoDetalhada.numero_titulo}</h5>
                    <h6 className="text-slate-500">VALOR TÍTULO (SALDO)</h6>
                    <h5>{formatCurrency(infoProtestoDetalhada.saldo)}</h5>
                </div>
                }
            </div>
        </Dialog>
    )
}

export default InfoProtestoDialog